import UserService from "@services/user/UserService";
import type { RootStore } from "@state/stores/types";
import { redirect } from "@state/utils";
import { THEME_SETTINGS } from "@theme-settings";
import { AccountTypes, getCurrentCulture, isGamesTheme } from "@utils";
import { mapAccountTypeToRequestContext } from "@utils/api-config/mapAccountTypeToRequestContext";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { action, observable } from "mobx";

class LogoutPopupStore {
	@observable isLogoutPopupActive: boolean = false;

	accountType: AccountTypes | null = null;
	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	public async displayLogoutOption() {
		if (THEME_SETTINGS.isLogoutPopupEnabled) {
			this.activatePopup();
			return;
		}

		await this.rootStore.userAuthStore.logoutUser();

		redirect(`/${getCurrentCulture()}/${DefaultPath.HOME}`);
	}

	@action.bound
	activatePopup() {
		this.isLogoutPopupActive = true;
	}

	@action.bound
	deactivatePopup() {
		this.isLogoutPopupActive = false;
	}

	@action.bound
	setAccountTypeForDeactivation() {
		if (this.rootStore.userAuthStore.isInternetUser) {
			this.accountType = AccountTypes.ONLINE;
		} else {
			this.accountType = AccountTypes.OFFLINE;
		}
	}

	@action.bound
	async deactivate() {
		this.rootStore?.realityCheckStore?.deactivatePopup();

		this.deactivatePopup();

		this.setAccountTypeForDeactivation();

		await UserService.deactivateUser(
			false,
			mapAccountTypeToRequestContext(this.accountType)
		);

		if (isGamesTheme()) {
			redirect(`/${getCurrentCulture()}/${DefaultPath.HOME}`);
		}
	}

	@action.bound
	async logout() {
		this.rootStore?.realityCheckStore?.deactivatePopup();

		this.deactivatePopup();

		await this.rootStore.userAuthStore.logoutUser();

		redirect(`/${getCurrentCulture()}/${DefaultPath.HOME}`);
	}

	@action.bound
	onDispose() {
		this.isLogoutPopupActive = false;
		this.accountType = null;
	}
}

export default LogoutPopupStore;
